/**
 *
 * Model Obj for communicating with Iterable Platform
 *
 */

const {isDevelopment} = require("./Env");


module.exports = (function(){

    var mdl = {};

    mdl.model__parseWPBody = function( obj ) {

        //check to see if we have a string, which is what WP returns
        if (typeof obj === 'string' || obj instanceof String) {
            // it's a string, so parse
            obj = JSON.parse( obj );

        }
        //check to see if we have a body in our obj
        if( obj.hasOwnProperty( 'body' ) ){
            //noe parse the body
            obj =   JSON.parse(obj.body);
        }

        return  !this.empty( obj ) ? obj : null ;

    };

     mdl.empty = function( data ) {

        if(typeof(data) === 'number' || typeof(data) === 'boolean')
        {
            return false;
        }
        if(typeof(data) === 'undefined' || data === null)
        {
            return true;
        }
        if(typeof(data.length) !== 'undefined')
        {
            return data.length === 0;
        }
        var count = 0;
        for(var i in data)
        {
            if(data.hasOwnProperty(i))
            {
                count ++;
            }
        }
        return count === 0;
    };

    // handles sending emails as confirmations for forms being completed
  mdl.model__handleEmailSubmission = async function(subject, message){
    if (isDevelopment()) {
      return;
    }

    const domain = 'https://itblapi.wpenginepowered.com/wp-json/itblbackend/v1';
    const url = `${domain}/send-email`;

    const payload = { subject, message };

    try {
        await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        console.error(e);
    }
  };

    //returns UTM parameters if any
    mdl.model__getUTMs = function(){
        const URLString     = (window.location.href).toLowerCase();
        const url           = new URL(URLString);

        return{
            URL                 : URLString,
            UTM_Source          : url.searchParams.get( 'utm_source' ),
            UTM_Medium          : url.searchParams.get( 'utm_medium' ),
            UTM_Campaign        : url.searchParams.get( 'utm_campaign' ),
            UTM_Term            : url.searchParams.get( 'utm_term' ),
            UTM_Content         : url.searchParams.get('utm_content'),
            referrer            : (document.referrer ) ? document.referrer : null , //if this is an empty string, then return null
            searchParams        : url.search

        };
    };

    //return obj for use
    return mdl;

})();



